export default function SettingsIcon({
  width = 16,
  height = 16,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25365 1.41353C6.11527 1.17783 5.81327 1.09692 5.57559 1.23187L3.26619 2.54308C3.14978 2.60917 3.06473 2.71918 3.03009 2.84849C2.99545 2.97779 3.01411 3.11559 3.08188 3.23103C3.84077 4.52364 2.87054 6.18884 1.33337 6.18884C1.05723 6.18884 0.833374 6.41269 0.833374 6.68881V9.31128C0.833374 9.58741 1.05723 9.81128 1.33337 9.81128C2.87015 9.81128 3.83987 11.4761 3.08083 12.769C3.01305 12.8844 2.9944 13.0222 3.02904 13.1515C3.06368 13.2808 3.14873 13.3909 3.26514 13.4569L5.57454 14.7681C5.81222 14.9031 6.11421 14.8222 6.25259 14.5865C7.03597 13.2521 8.96517 13.2521 9.74857 14.5864C9.88691 14.8221 10.1889 14.903 10.4266 14.7681L12.736 13.4569C12.8524 13.3908 12.9374 13.2807 12.9721 13.1515C13.0067 13.0221 12.9881 12.8843 12.9203 12.7689C12.1611 11.4757 13.1303 9.81128 14.6667 9.81128C14.9428 9.81128 15.1667 9.58741 15.1667 9.31128V6.68881C15.1667 6.41269 14.9428 6.18884 14.6667 6.18884C13.1299 6.18884 12.1602 4.52398 12.9192 3.23109C12.987 3.11565 13.0057 2.97786 12.971 2.84855C12.9364 2.71925 12.8514 2.60924 12.735 2.54314L10.4256 1.23194C10.1878 1.09698 9.88584 1.1779 9.74751 1.4136C8.96464 2.74707 7.03657 2.74704 6.25365 1.41353ZM8.00004 10.3333C9.28871 10.3333 10.3334 9.28868 10.3334 8.00001C10.3334 6.71134 9.28871 5.66668 8.00004 5.66668C6.71137 5.66668 5.66671 6.71134 5.66671 8.00001C5.66671 9.28868 6.71137 10.3333 8.00004 10.3333Z"
        fill={color}
      />
    </svg>
  );
}
